import { state } from './state.js';

export const modals = {
  showPackModal(previewImage, products, total) {
    const qty = parseInt(state.elements.qtyInput.value, 10) || 1;
    const html = `
      <div id="acpb-modal" class="modal fade show" style="display:block;background:rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content p-4">
            <div class="modal-header border-0">
              <h4 class="modal-title">Pack ajouté au panier</h4>
              <button type="button" class="btn-close" id="acpb-close-modal"></button>
            </div>
            <div class="modal-body text-center">
              ${previewImage ? `<img src="${previewImage}" class="img-fluid rounded mb-3" style="max-height:200px;">` : ''}
              <ul class="list-group mb-3 text-start">
                ${products.map(p => `
                  <li class="list-group-item d-flex justify-content-between">
                    <span class="d-flex">${p.fullname}</span>
                    <span>${qty} × ${p.price.toFixed(2)} €</span>
                  </li>`).join('')}
              </ul>
              <h5>Total du pack : ${(qty * total).toFixed(2)} €</h5>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <a href="${prestashop.urls.pages.cart}?action=show" class="btn btn-primary">Voir le panier</a>
              <button class="btn btn-outline-secondary" id="acpb-continue">Continuer mes achats</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);

    const close = () => {
      document.querySelector('#acpb-modal')?.remove();
      location.reload();
    };

    document.getElementById('acpb-close-modal')?.addEventListener('click', close);
    document.getElementById('acpb-continue')?.addEventListener('click', close);
  }
};
